import { USER_SETTINGS_PREFIX } from '#pplx/frontend/apps/ask/user-settings/storage/constants.js';
import { useLocalStorage } from '#pplx/frontend/browser-storage/hooks/useLocalStorage.js';
import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
export const hasLocalUserSetting = (name) => SafeLocalStorage.getItem(`${USER_SETTINGS_PREFIX}${name}`) !== null;
/**
 * A hook to get a local user setting.
 * @param name - The name of the local user setting.
 * @param initialValue - The initial value of the local user setting.
 * @returns The local user setting.
 */
export function useLocalUserSettings(name, initialValue) {
    return useLocalStorage(`${USER_SETTINGS_PREFIX}${name}`, initialValue);
}
//# sourceMappingURL=getLocalUserSettings.js.map